<template>
  <!-- 登录页面 -->
  <div id="login">
  <el-main>
    <h1>Sign in</h1>
    <el-row>
      <el-container>
      <p style="color: #dcdfe6;margin: 0 auto;align-self: center;margin-left: 15px;">Email:</p>
      <el-input
        placeholder="******@gmail.com"
        v-model="validateForm.username"
        clearable>
      </el-input>
      </el-container>
    </el-row>
    <el-row>
      <div style="background-color: #dcdfe6;height: 0.0625rem;width: 100%;"></div>
      </el-row>
      <el-row>
      <el-container>
        <el-input
          placeholder="Verification code"
          v-model="validateForm.password"
          clearable>
        </el-input>
        <el-button @click="SendCode" class="SendBtn" id="btnSendCode1" fill>Send</el-button>
      </el-container>
      </el-row>
      <el-row>
        <div style="background-color: #dcdfe6;height: 0.0625rem;width: 100%;"></div>
        </el-row>

        <el-row>
        <el-button @click="submit" class="LoginBtn" fill>Log in</el-button>
        </el-row>
    </el-container>
    <!-- <mu-form ref="form" :model="validateForm" class="mu-demo-form">
      <mu-form-item label="Email" help-text="******@gmail.com" prop="username" :rules="usernameRules" class="email">
        <mu-text-field v-model="validateForm.username" prop="username"></mu-text-field>
      </mu-form-item>
      <mu-form-item label="Verification code" prop="password" :rules="passwordRules">
          <mu-text-field v-model="validateForm.password" prop="password" class="code"></mu-text-field>
          <input @click="SendCode" id="btnSendCode1" type="button" class="btn btn-default" value="Send" />
      </mu-form-item>
      <mu-form-item class="btn_item">
        <mu-button @click="submit" class="signin">Sign in</mu-button>
      </mu-form-item>
    </mu-form> -->
  </el-main>
  </div>
<!--  <div id="login">
  <div class="modal_content">
  			<h1>Sign in</h1>
  			<div>
  				<label for="phone1">注册手机号：</label><br />
  				<input id="phone1" type="text" autocomplete="off" placeholder="请输入已绑定的手机号"/>
  			</div>
  			<div>
  				<label for="code1">验证码：</label>
  				<div class="code1">
  					<input id="code1" type="text" autocomplete="off" placeholder="短信验证码"/>
  					<input id="btnSendCode1" type="button" class="btn btn-default" value="获取验证码" onClick="sendMessage1()" />
  				</div>
  			</div>
  			<div class="next">
  				<button onclick="binding()">确定</button>
  			</div>
  		</div>
      </div> -->
</template>

<script>
  import $ from 'jquery'
  // import Vue from 'vue'
  // import {Logins} from '../assets/js/Login.js'
  import {LoginAction,sendMessage1} from '../assets/js/Login.js'
  export default {
    data () {
      return {
        InterValObj1:0,
        usernameRules: [
          { validate: (val) => !!val, message: 'Email must be filled in'},
          { validate: (val) => val.length >= 3, message: 'The length of the mailbox must be longer than 3'}
        ],
        passwordRules: [
          { validate: (val) => !!val, message: 'The verification code must be filled in'},
          { validate: (val) => val.length >= 4 && val.length <= 4, message: 'The verification code must be 4'}
          // { validate: (val) => val.length >= 4 && val.length <= 6, message: '密码长度大于3小于10'}
        ],
        validateForm: {
          username: '',
          password: '',
          isAgree: false
        },

      }
    },
    mounted() {
      window.login = this;
      // Logins();
    },
    methods: {
      submit () {
        LoginAction(this.validateForm.username,this.validateForm.password,function() {
          // console.log("登录验证成功");
          window.login.$router.replace("/M/Home");
        })
        // console.log(this.validateForm.username+":"+this.validateForm.password);
          // this.$router.replace("/M/Home");
        // this.$refs.form.validate().then((result) => {
        //   console.log('form valid: ', result)
        // });
      },
      SendCode(){
        sendMessage1();
      },
      clear () {
        this.$refs.form.clear();
        this.validateForm = {
          username: '',
          password: '',
          isAgree: false
        };
      }
    }
  };
  // import 'bootstrap/dist/css/bootstrap.min.css'
  // import 'bootstrap/dist/js/bootstrap.min.js'

  // export default {
  //   name: 'Login',
  //   data() {
  //     return {
  //     }
  //   },
  //   created() {

  //   },
  //   methods() {

  //   },
  //   methods: {

  //   }
  // }

  // var phoneReg = /(^1[3|4|5|7|8]\d{9}$)|(^09\d{8}$)/;//手机号正则
  // 			var count = 60; //间隔函数，1秒执行
  // 			var InterValObj1; //timer变量，控制时间
  // 			var curCount1;//当前剩余秒数
  // 			/*第一*/
  // 			function sendMessage1() {
  // 				curCount1 = count;
  // 				var phone = $.trim($('#phone1').val());
  // 				if (!phoneReg.test(phone)) {
  // 					alert(" 请输入有效的手机号码");
  // 					return false;
  // 				}
  // 				//设置button效果，开始计时
  // 				$("#btnSendCode1").attr("disabled", "true");
  // 				$("#btnSendCode1").val( + curCount1 + "秒再获取");
  // 				InterValObj1 = window.setInterval(SetRemainTime1, 1000); //启动计时器，1秒执行一次
  // 				//向后台发送处理数据

  // 			}
  // 			function SetRemainTime1() {
  // 				if (curCount1 == 0) {
  // 					window.clearInterval(InterValObj1);//停止计时器
  // 					$("#btnSendCode1").removeAttr("disabled");//启用按钮
  // 					$("#btnSendCode1").val("重新发送");
  // 				}
  // 				else {
  // 					curCount1--;
  // 					$("#btnSendCode1").val( + curCount1 + "秒再获取");
  // 				}
  // 			}

  // 			/*提交*/
  // 			function binding(){
  // 				alert(1)
  // 			}
</script>

<style>

  @import '../../Comm/css/CommCSS.css';
  /* 登录页面样式 */
  /* @import "../assets/css/login.css"; */
/* .mu-demo-form {
  width: 100%;
  max-width: 460px;
} */

#login body {
  margin: 0;
  padding: 0;
}

#login h1 {
  width: 100%;
  padding: 30px;
  margin-top: 30%;
  color: #303644;
}
#login .el-main {
  overflow: hidden;
}
#login .el-row {
    height: 2.5rem;
}
#login .el-input {
    position: relative;
    font-size: 14px;
    display: inline-block;
    width: 100%;
    height: 100%;
}
#login .el-input__inner {
  /* height: 100%; */
  border: 0px solid #dcdfe6;
}
#login .SendBtn {
    /*margin: 0.625rem; 水平居中*/
    /* display: flex; */
    /* padding: 30px; */
    font-size: 15px;
    color: #FFFFFF;
    background-color: #303644;
    border-radius: 30px;
    width: 9.375rem;
  }
#login .LoginBtn {
  font-size: 35px;
      color: #fff;
      background-color: #303644;
      border-radius: 30px;
      width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/OK_Scott/components/Login.vue